module.exports = __webpack_public_path__ + "img/chart1-s.ff433106.png";